module.exports = __webpack_public_path__ + "static/media/пе.70f95214.mp3";